// registroCampos.js — Normaliza `config_json.registro_config.campos`.
//
// Convive el formato viejo (objeto {clave: {visible, requerido, etiqueta}}, que
// solo listaba los campos OPCIONALES porque nombre/email/password iban fijos en
// el formulario) con el nuevo (array ordenado [{key, visible, requerido, ancho}]
// que incluye también los campos base y define el orden de render).
//
// AdminProyectos ya hace esta migración al abrir el panel; el formulario de
// registro tiene que hacer la misma lectura, si no un proyecto guardado en el
// formato viejo se queda sin nombre/email/password (solo se ven los opcionales).

const ORDEN_OPCIONALES = ['convenio', 'telefono', 'especialidad', 'pais', 'dni', 'subrol'];
const BASE = [
  { key: 'nombre', visible: true, requerido: true, ancho: 100 },
  { key: 'email', visible: true, requerido: true, ancho: 100 },
  { key: 'password', visible: true, requerido: true, ancho: 100 },
];

/** Devuelve siempre un array ordenado de campos, venga del formato que venga. */
export const normalizarCampos = (registroConfig) => {
  const entrante = registroConfig?.campos;

  let campos;
  if (Array.isArray(entrante)) {
    campos = entrante.map(c => ({ ancho: 100, ...c }));
  } else {
    const obj = entrante || {};
    campos = ORDEN_OPCIONALES.map(k => ({
      key: k,
      visible: !!obj[k]?.visible,
      requerido: !!obj[k]?.requerido,
      ancho: 100,
      ...(obj[k]?.etiqueta ? { etiqueta: obj[k].etiqueta } : {}),
    }));
  }

  // Los campos base van al frente si el proyecto es anterior al formato array.
  const faltantes = BASE.filter(b => !campos.some(c => c.key === b.key));
  return faltantes.length ? [...faltantes, ...campos] : campos;
};

// Campos de selección múltiple (hoy: especialidad con tipo 'checkbox'). El valor
// viaja como un string "A, B" para no cambiar la columna ni el resto del sistema.
/** "A, B" → ['A','B'] */
export const listaValores = (str) =>
  str ? String(str).split(',').map(s => s.trim()).filter(Boolean) : [];

/** Agrega o quita `valor` del string multi-valor y lo devuelve normalizado. */
export const alternarValor = (str, valor) => {
  const arr = listaValores(str);
  return (arr.includes(valor) ? arr.filter(v => v !== valor) : [...arr, valor]).join(', ');
};

// Caja de un grupo de casillas. Con pocas opciones se muestra suelta; a partir de
// UMBRAL_SCROLL se recorta y aparece un scroll chico, para que un catálogo largo
// (ej. 89 instituciones) no estire el formulario.
const UMBRAL_SCROLL = 8;
export const cajaCasillas = (cantidad = 0) => {
  const conScroll = cantidad > UMBRAL_SCROLL;
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.35rem',
    padding: conScroll ? '0.5rem 0.6rem' : '0.2rem 0',
    ...(conScroll ? {
      maxHeight: '190px',
      overflowY: 'auto',
      border: '1px solid #cbd5e1',
      borderRadius: 8,
      scrollbarWidth: 'thin',
    } : {}),
  };
};

/** Busca un campo por clave en la config normalizada. */
export const buscarCampo = (registroConfig, key) =>
  normalizarCampos(registroConfig).find(c => c.key === key);
